import { notification } from 'antd';

export const API_URL = process.env.REACT_APP_API_URL;

export const getToken = () => {
  const token = JSON.parse(localStorage.getItem('userToken'));
  return {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };
};

// Enums
export const currencyEnums = {
  INR: 1,
  USD: 2,
};

export const billingCycleEnums = {
  MONTHLY: 1,
  YEARLY: 2,
  LIFETIME: 3,
};

// Functions
export function getKeyByValue(object, targetValue) {
  for (const key in object) {
    if (object.hasOwnProperty(key) && object[key] === targetValue) {
      return key;
    }
  }
  return null; // Return null if the value is not found
}

// Validators
export const validateEmail = (rule, value, callback) => {
  if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,4})+$/.test(value)) {
    callback(); // Validation passed
  } else {
    callback('Invalid email format'); // Validation failed
  }
};

export const logoutUser = ({ navigate, error }) => {
  if (error?.response?.status === 401) {
    notification.error({ message: 'Session TimeOut Logging out User' });

    localStorage.clear();
    navigate('/Login', { replace: true });
  }
};
